import React from "react";
import { Div, Text3 } from "components/Base";
import styleSpects from "components/Base/Base/styleSpecs";

const FilterLabel = ({ text, selected, color }) => (
  <Div display="row.space-between.center" style={{ gap: "6px" }}>
    <Text3>{text}</Text3>
    {selected && (
      <i
        className={`material-icons-outlined check`}
        style={{ color: color || "#4263EB", fontSize: styleSpects.fontSize[2] }}
      >
        check
      </i>
    )}
  </Div>
);

export default FilterLabel;
